const win = window;
const html = document.documentElement;
let lastWinScroll = 0;
const setScreenHeight = () => {
    html.style.setProperty('--lock-sh', `${win.innerHeight}px`);
};
export const toggleBodyScroll = (value) => {
    if (value) {
        lastWinScroll = win.scrollY;
        html.style.setProperty('--lock-scrl', String(lastWinScroll));
        html.style.setProperty('--lock-pr', String(win.innerWidth - html.clientWidth));
        setScreenHeight();
        win.addEventListener('resize', setScreenHeight);
        html.classList.add('body:locked');
        window.setTimeout(() => { html.scrollTo(0, 0); }, 99);
    }
    else {
        win.removeEventListener('resize', setScreenHeight);
        html.classList.remove('body:locked');
        win.scrollTo(0, lastWinScroll);
    }
};
